import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Rush1 from '../media/Rush/Gallery/rush1.png';
import Rush2 from '../media/Rush/Gallery/rush2.jpg';
import Rush3 from '../media/Rush/Gallery/rush3.jpg';
import Rush4 from '../media/Rush/Gallery/rush4.jpg';
import Rush5 from '../media/Rush/Gallery/rush5.jpg';
import Rush6 from '../media/Rush/Gallery/rush6.jpg';
import Rush7 from '../media/Rush/Gallery/rush7.jpg';
import Rush8 from '../media/Rush/Gallery/rush8.jpg';
import Rush9 from '../media/Rush/Gallery/rush9.jpg';
import Rush12 from '../media/Rush/Gallery/rush12.jpg';
import Rush16 from '../media/Rush/Gallery/rush16.jpg';
import Rush19 from '../media/Rush/Gallery/rush19.png';



export default function RushGallery() {
  return (
    <>
        <ImageList sx={{ width: '100%', height: '100%' }} variant="woven" cols={3} gap={8}>
        {itemData.map((item) => (
            <ImageListItem key={item.img}>
            <img
                srcSet={`${item.img}?w=161&fit=crop&auto=format&dpr=2 2x`}
                src={`${item.img}?w=161&fit=crop&auto=format`}
                alt={item.title}
                loading="lazy"
            />
            </ImageListItem>
        ))}
        </ImageList>
    </>
  );
}

const itemData = [
  {
    img: Rush1,
    title: 'Rush1',
  },
  {
    img: Rush2,
    title: 'Rush2',
  },
  {
    img: Rush3,
    title: 'Rush3',
  },
  {
    img: Rush4,
    title: 'Rush4',
  },
  {
    img: Rush5,
    title: 'Rush5',
  },
  {
    img: Rush6,
    title: 'Rush6',
  },
  {
    img: Rush7,
    title: 'Rush7',
  },
  {
    img: Rush8,
    title: 'Rush8',
  },
  {
    img: Rush9,
    title: 'Rush9',
  },
  {
    img: Rush12,
    title: 'Rush12',
  },
  {
    img: Rush16,
    title: 'Rush16',
  },
  {
    img: Rush19,
    title: 'Rush19',
  },
];